'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtDepthCategoryInsurance(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtDepthCategoryInsurance');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1985 5.215H22.3485V6.76H14.1135V5.215H17.2635V4H19.1985V5.215ZM23.9535 7.81V4.15H25.8735V12.19H23.9535V9.445H22.2285V7.81H23.9535ZM21.7635 9.655V9.82C21.7635 11.395 20.2185 12.175 18.2385 12.175C16.2585 12.175 14.7135 11.395 14.7135 9.82V9.655C14.7135 8.08 16.2585 7.285 18.2385 7.285C20.2185 7.285 21.7635 8.08 21.7635 9.655ZM16.5735 9.685V9.79C16.5735 10.33 17.2935 10.645 18.2385 10.645C19.1835 10.645 19.9035 10.33 19.9035 9.79V9.685C19.9035 9.145 19.1835 8.83 18.2385 8.83C17.2935 8.83 16.5735 9.145 16.5735 9.685ZM25.8735 18.16H16.3485V12.955H25.8735V18.16ZM23.9535 14.575H18.2685V16.51H23.9535V14.575Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56 12.835V15.43H13.2V17.185H0V15.43H5.64V12.835H1.545V4.94499H3.45V7.22499H9.75V4.94499H11.67V12.835H7.56ZM9.75 8.96499H3.45V11.11H9.75V8.96499Z",
    fill: fill || '#1E1E23'
  }));
}
var IcTxtDepthCategoryInsurance$1 = /*#__PURE__*/memo(IcTxtDepthCategoryInsurance);

export { IcTxtDepthCategoryInsurance$1 as default };
